<template>
  <div class="reference-popover">
    <!-- 标题（添加a标签实现跳转，对齐查看原文链接） -->
    <a href="javascript:void(0);" class="ref-title-link" v-if="refData.url" @click="openArticleInRightPanel(refData)">
      <div class="ref-title">{{ refData.title || "暂无标题" }}</div>
    </a>
    <!-- 无url时不添加链接 -->
    <div class="ref-title" v-else>
      {{ refData.title || "暂无标题" }}
    </div>

    <!-- 作者 -->
    <div class="ref-author">{{ refData.authors && refData.authors.length ? formatAuthors(refData.authors) : "未知作者" }}</div>

    <!-- 元信息（机构/年份） -->
    <div class="ref-meta">
      <span>{{ refData.source || "未知来源" }}</span>
      <span v-if="refData.year || refData.pubdate"> · {{ refData.year || refData.pubdate }}</span>
      <span v-if="refData.score !== undefined && refData.score !== null"> · score {{ formatScore(refData.score) }}</span>
    </div>

    <!-- DOI -->
    <div class="ref-doi" v-if="refData.doi">DOI: {{ cleanDoi(refData.doi) }}</div>

    <!-- 论文贡献（突出展示） -->
    <div class="ref-description" v-if="refData.abstract">
      <span class="desc-content">{{ refData.abstract }}</span>
    </div>
    <div class="ref-description" v-if="refData.abstract_zh">
      <span class="desc-content">{{ refData.abstract_zh }}</span>
    </div>

    <!-- 底部操作区 -->
    <div class="tooltip-footer">
      <a class="view-original-btn" @click="full_txt_art_analysis(refData.sid)"> <i class="fa el-icon-finished"></i> 全文分析 </a>

      <a href="javascript:void(0);" class="view-original-btn" @click="openArticleInRightPanel(refData)"> <i class="fa el-icon-link"></i> 查看原文 </a>
    </div>
  </div>
</template>

<script>
import { openArticleDetail } from "../utils/openArticleDetail";
import { cleanDoi } from "@/utils/doiUtils";
export default {
  name: "RefPopoverContent",
  props: {
    refData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  methods: {
    cleanDoi(doi) {
      return cleanDoi(doi);
    },
    formatAuthors(authors) {
      // 后端已在 ES 边界将作者归一化为字符串数组，前端直接消费字符串。
      if (!Array.isArray(authors)) return "未知作者";
      const authorText = authors.filter(author => typeof author === "string" && author).join(", ");
      return authorText || "未知作者";
    },
    formatScore(score) {
      const numberScore = Number(score);
      if (Number.isNaN(numberScore)) return score;
      return numberScore.toFixed(2);
    },
    full_txt_art_analysis(sid) {
      this.$emit("full_txt_art_analysis", sid);
    },
    // 在右侧面板打开文章
    openArticleInRightPanel(article) {
      openArticleDetail(article);
    },
  },
};
</script>

<style scoped>
/* 基础容器样式（完全对齐组件A的tooltip-box） */
.reference-popover {
  position: relative; /* 对齐A的定位上下文 */
  background: var(--bg-front);
  border-radius: 8px; /* 对齐A的圆角 */
  /* box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);  */
  font-size: 14px;
  line-height: 1.7;
  box-sizing: border-box;
  /* border: 1px solid var(--label-border, #e5e7eb);  */
  /* 高度自适应，对齐A的最终样式 */
  height: auto;
  max-height: none;
  overflow-y: visible;
  /* 迁移A的过渡动画（如果B需要显隐动画可启用） */
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
  transition: all 0.3s ease;
}

/* 标题链接：完全对齐组件A的tooltip-title-link */
.ref-title-link {
  text-decoration: none;
  display: block;
  transition: color 0.2s ease; /* 迁移A的过渡动画 */
}

/* 标题样式：100%对齐组件A的tooltip-title */
.ref-title {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--label-border); /* 对齐A的分隔线 */
  color: var(--a-color); /* 迁移A的颜色变量 */
  word-break: break-all;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.2s ease; /* 迁移A的过渡动画 */
  font-weight: bold;
}

/* 标题hover效果：完全对齐组件A */
.ref-title-link:hover .ref-title {
  color: var(--a-color-hover); /* 迁移A的hover颜色变量 */
}

/* 作者信息：完全对齐组件A的author-info */
.ref-author {
  color: var(--txt-color2, #4b5563); /* 迁移A的颜色变量 */
  margin-bottom: 6px;
  word-break: break-all;
  line-height: 1.7; /* 对齐A的行高 */
}

/* 核心期刊信息：优化对齐组件A的core-journal */
.ref-core-journal {
  margin-bottom: 6px;
  padding: 4px 8px;
  background-color: var(--tag-bg-blue, #f0f8ff); /* 迁移A的背景变量 */
  border-radius: 4px; /* 对齐A的圆角 */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px; /* 对齐A的间距 */
  /* 迁移A的细微阴影（可选） */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.core-tag {
  font-size: 12px;
  color: #409eff;
  font-weight: 600;
  line-height: 1; /* 对齐A的行高 */
}
.core-part {
  font-size: 13px;
  color: #2d8cf0;
  font-weight: 600;
  line-height: 1;
}
.core-subject {
  font-size: 13px;
  color: #0d83f8; /* 对齐A的颜色 */
  line-height: 1;
}

/* 元信息：完全对齐组件A的meta-info */
.ref-meta {
  font-size: 13px;
  color: var(--txt-color2, #6b7280); /* 迁移A的颜色变量 */
  margin-bottom: 6px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 1.7; /* 对齐A的行高 */
}

.meta-divider {
  margin: 0 6px; /* 完全对齐A的分隔符间距 */
  color: #d1d5db; /* 完全对齐A的分隔符颜色 */
  line-height: 1; /* 对齐A的行高 */
}

/* DOI信息：完全对齐组件A的doi-info */
.ref-doi {
  font-size: 12px;
  color: #86909c; /* 对齐A的颜色 */
  margin-bottom: 8px;
  word-break: break-all;
  line-height: 1.7; /* 对齐A的行高 */
}

/* 论文贡献：完全对齐组件A的description-wrap */
.ref-description {
  margin: 8px 0;
  padding: 8px; /* 对齐A的内边距 */
  background-color: var(--label-bg3, #f8fafc); /* 迁移A的背景变量 */
  border-left: 3px solid var(--a-color, #3b82f6); /* 迁移A的左侧边框 */
  border-radius: 2px; /* 对齐A的圆角 */
  /* 迁移A的细微阴影（可选） */
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.desc-content {
  font-size: 13px;
  color: var(--txt-color, #1f2937); /* 迁移A的颜色变量 */
  line-height: 1.6; /* 对齐A的行高 */
  /* 移除折叠，对齐A的最终样式 */
  max-height: none;
  overflow: visible;
}

/* 链接行：完全对齐组件A的tooltip-footer */
.ref-link-row {
  padding-top: 10px;
  border-top: 1px solid var(--label-border); /* 完全对齐A的分隔线 */
  display: flex;
  gap: 8px; /* 对齐A的按钮间距 */
  flex-wrap: wrap;
  justify-content: flex-end; /* 右对齐，对齐A */
  margin-top: 10px;
}

.ref-link {
  text-decoration: none;
}

/* 按钮样式：100%对齐组件A的view-original-btn */
.ref-link el-button {
  background: var(--btn-bg2, #3b82f6) !important; /* 迁移A的按钮背景变量 */
  color: var(--btn-color2, #ffffff) !important; /* 迁移A的按钮文字变量 */
  border: none !important;
  border-radius: 4px !important; /* 对齐A的圆角 */
  padding: 6px 12px !important; /* 对齐A的内边距 */
  font-size: 13px !important; /* 对齐A的字号 */
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important; /* 对齐A的图标间距 */
  transition: background-color 0.2s ease !important; /* 迁移A的过渡动画 */
  /* 移除Element默认样式干扰 */
  box-shadow: none !important;
  outline: none !important;
}

/* 按钮hover：完全对齐组件A */
.ref-link el-button:hover {
  background-color: var(--btn-bg-hover2, #2563eb) !important; /* 迁移A的hover变量 */
  color: var(--btn-color2, #ffffff) !important;
}

/* 响应式适配：完全迁移组件A的@media规则 */
@media (max-width: 640px) {
  .reference-popover {
    width: 280px !important; /* 对齐A的移动端宽度 */
  }
}

/* 底部操作区 */
.tooltip-footer {
  padding-top: 10px;
  border-top: 1px solid #f3f4f6;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.view-original-btn {
  background: var(--btn-bg2);
  color: var(--btn-color2);
  border: none;
  border-radius: 20px;
  padding: 6px 15px;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s ease;
}

.view-original-btn:hover {
  background-color: var(--btn-bg-hover2);
}
</style>
